/* eslint-disable parog-web/no-glint-expect-error-directive */
import { hash } from '@ember/helper';
import Component from '@glimmer/component';
import type { Signature as S2 } from 'parog-web/components/fui-calendar';
import FuiCalendar from 'parog-web/components/fui-calendar';
import { datetimeFormat } from 'parog-web/helpers/datepicker-format';

export interface S {
  Args: {
    labelName?: string;
    propertyName?: string;
    isMandatory?: boolean;
    onChange: S2['Args']['onFocusOut'];
  } & Pick<S2['Args'], 'selected' | 'disabled' | 'isReadOnly'>;
}

export default class DateTimePickerComponent extends Component<S> {
  formatter = {
    datetime: datetimeFormat
  };

  <template>
    {{#if @labelName}}
      <label>
        {{@labelName}}{{if @isMandatory ' *'}}
      </label>
    {{/if}}
    <FuiCalendar
      @selected={{@selected}}
      {{! @glint-expect-error }}
      @settings={{hash type='datetime' formatter=this.formatter ampm=false}}
      @disabled={{@disabled}}
      @onFocusOut={{@onChange}}
      @isReadOnly={{@isReadOnly}}
      @format='datetime'
      data-test-input={{@propertyName}}
    />
  </template>
}
